import {
    ADD_LOGIN,
    LOGIN_ERROR,
    AUTH_SUCCESS
} from '../actions/types'

const initialState = {
    loginData: [],
    loading: true,
    userData: {},
    error: {}
}

const reducer = function (state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case LOGIN_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            }
        case ADD_LOGIN:
            return {
                ...state,
                loginData: payload,
                loading: false
            }
        case AUTH_SUCCESS:
            return {
                ...state,
                userData: payload,
                loading: false
            }
        default:
            return state
    }
}

export default reducer;